export default __webpack_public_path__ + "static/media/postlogin-switch-card-banner-mobile.a1348b11.png";